import { styled } from '@nykaa/ui-components';
import { FONTS } from 'shared/styles/base';
import { SPACING } from './constants';

export const Main = styled.div<{
  inFocus: boolean;
  isDisabled: boolean;
  isValid: boolean;
  isError: boolean;
  spacingType: string;
}>`
  background: ${({ theme }) => theme.colors.surface20};
  border-radius: ${({ theme }) => theme.borders.radius10};
  position: relative;
  height: ${({ spacingType }) => {
    return SPACING[spacingType];
  }};
  border-bottom: 1px solid ${({ theme }) => theme.colors.textOutline};
  ${({ isDisabled, inFocus, isValid, isError, theme }) => {
    if (isError) {
      return `
                border-bottom: 2px solid transparent;
                background: rgba(182, 0, 0, 0.12);
            `;
    }
    if (isDisabled) {
      return `
                pointer-events: none; 
                opacity: 0.6; 
                cursor: not-allowed
            `;
    }
    if (isValid) {
      return `
                border-bottom: 2px solid ${theme.colors.textOutline};
            `;
    }
    if (inFocus) {
      return `
                border-bottom: 2px solid transparent;
                background: ${theme.colors.surface20};
            `;
    }
  }}
`;

export const Label = styled.label<{
  inFocus: boolean;
  isValid: boolean;
}>`
  color: ${({ theme }) => theme.colors.textSecondary};
  ${({ theme }) => theme.typography.bodyLarge};
  position: absolute;
  pointer-events: none;
  transition: 0.2s ease all;
  text-transform: capitalize;
  transform-origin: top left;
  ${({ inFocus, isValid, theme }) => {
    if (inFocus || isValid) {
      return `
                transform: scale(0.75) translate3d(0, -100%, 0);
                color: ${theme.colors.textSecondary};
            `;
    }
    return 'transform: scale(1) translate3d(0, -50%, 0)';
  }};
  left: 0;
  top: ${() => {
    return '50%';
  }};
`;

export const FlexWrapper = styled.div<{
  hasTrailingComponent?: boolean;
  hasLeadingComponent?: boolean;
}>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
  ${({ hasTrailingComponent }) => hasTrailingComponent && 'padding-right: 0;'};
  max-width: 100%;
`;

export const InputWrapper = styled(FlexWrapper)`
  align-items: flex-end;
  padding: 0;
  margin: ${({ theme }) => `0 0 0 ${theme.spacing.spacing60}`};
`;

export const InputElement = styled.input<{ inFocus: boolean }>`
  ${({ theme }) => theme.typography.bodyLarge}
  font-family: ${FONTS.BASE_FAMILY};
  margin: ${({ theme }) =>
    `${theme.spacing.spacing60} ${theme.spacing.spacing60} ${theme.spacing.spacing20} 0`};
  background: transparent;
  width: 100%;
  display: block;
  border: none;
  ${({ theme }) => `color:  ${theme.colors.textPrimary};
  caret-color: ${theme.colors.secondary};`}
  outline: none;
  padding: 0;
  cursor: pointer;
  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }
  &::placeholder {
    letter-spacing: 0.25px;
    text-transform: capitalize;
    opacity: 0;
    ${({ inFocus, theme }) => inFocus && `color: ${theme.colors.textDisabled}; opacity: 1;`}
  }
`;

export const Bar = styled.span<{ isError?: boolean; inFocus: boolean; isValid: boolean }>`
  position: absolute;
  bottom: -3px;
  display: block;
  width: 100%;
  &:after {
    content: '';
    display: block;
    height: 2px;
    width: 100%;
    bottom: 1px;
    position: absolute;
    background: ${({ theme }) => theme.colors.secondary};
    transition: 0.3s ease transform;
    transform: scaleX(0);
    transform-origin: top center;
    ${({ inFocus, isError, isValid, theme }) => {
      if (isError) {
        return `
                    width: 100%; 
                    left: 0px; 
                    transform: scaleX(1); 
                    background: #b60000;
                    border-radius: ${theme.borders.radius10};
                `;
      }
      if (inFocus) {
        return `transform: scaleX(1);`;
      }
      if (isValid) {
        return ` 
                    transform: scaleX(0); 
                    background-color: transparent;
                `;
      }
    }}
  }
`;

export const HelperText = styled.p<{ isError: boolean }>`
  ${({ theme }) => theme.typography.bodySmall}
  color: ${({ theme, isError }) => (isError ? theme.colors.warning : theme.colors.textSecondary)};
  margin: ${({ theme }) => `${theme.spacing.spacing20} 0`};
  position: relative;
`;

export const Sibling = styled.div`
  flex-shrink: 0;

  button,
  a,
  [role='button'] {
    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: 2px solid ${({ theme }) => theme.colors.primary};
      outline-offset: 2px;
      border-radius: 4px;
    }
  }
`;

export const Counter = styled.p`
  text-align: right;
  margin: ${({ theme }) => `${theme.spacing.spacing40} 0 0`};
  ${({ theme }) => theme.typography.bodySmall};
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const IconWrapper = styled.span`
  position: absolute;
  right: 0;
`;
